export const Currency = {
  EUR: {
    symbol: "€",
  },
};

export enum PriceMode {
  Gross = "gross",
  Net = "net",
}

export enum Markup {
  Absolute = "abs",
  Percent = "percent",
}

export const FLOATING_PORTAL_ROOT_ID = "floating-portal-root";

export const DEMO_SHOP_REGISTER_HANDLER_URL =
  "https://b2bgate.de/handlerregistrierung";
export const DEMO_SHOP_REGISTER_SUPPLIER_URL =
  "https://b2bgate.de/lieferantenregistrierung";

export const DEMO_SHOP_LOGIN = "shop@exonn.de";
export const DEMO_SHOP_PASSWORD = "password";

export enum FileTypes {
  Text = "text/plain",
  Csv = "text/csv",
  AnyImage = "image/*",
  Png = "image/png",
  Jpeg = "image/jpeg",
  Zip = "application/zip",
  ZipCompressed = "application/zip-compressed",
  XZip = "application/x-zip",
  XZipCompressed = "application/x-zip-compressed",
  Pdf = "application/pdf",
  Xml = "application/xml",
  Xml2 = "text/xml",
}
